import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'

export const hWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ横1(先端)
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ横2
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
  // ウェブ縦
  ctx.beginPath()
  ctx.moveTo(241, 235) // 左＿上
  ctx.quadraticCurveTo(254, 267, 254, 267) // 左＿下
  ctx.quadraticCurveTo(265, 243, 293, 208) // 右＿下
  ctx.quadraticCurveTo(283, 168, 283, 168) // 右＿上
  ctx.quadraticCurveTo(254, 199, 241, 237) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // Hウェブ縦＿左＿外側
  ctx.moveTo(245, 235) // 上
  ctx.quadraticCurveTo(255, 262, 255, 262) // 下
  // Hウェブ縦＿左＿内側
  ctx.moveTo(247, 231) // 上
  ctx.quadraticCurveTo(257, 259, 257, 259) // 下
  // // Hウェブ縦＿右＿内側
  ctx.moveTo(278, 178) // 上
  ctx.quadraticCurveTo(287, 210, 287, 210) // 下
  // // Hウェブ縦＿右＿外側
  ctx.moveTo(281, 175) // 上
  ctx.quadraticCurveTo(290, 210, 290, 210) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}

export const hJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ縦
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(266, 260) // 左＿上
  ctx.quadraticCurveTo(273, 275, 273, 275) // 左＿下
  ctx.quadraticCurveTo(319, 218, 319, 218) // 右＿下
  ctx.quadraticCurveTo(314, 190, 314, 190) // 右＿上
  ctx.quadraticCurveTo(284, 219, 266, 260) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // Hウェブ縦＿左＿外側
  ctx.moveTo(268, 260) // 上
  ctx.quadraticCurveTo(276, 273, 276, 273) // 下
  // // Hウェブ縦＿左＿内側
  ctx.moveTo(270, 257) // 上
  ctx.quadraticCurveTo(277, 270, 277, 270) // 下
  // // // Hウェブ縦＿右＿内側
  ctx.moveTo(308, 198) // 上
  ctx.quadraticCurveTo(313, 220, 313, 222) // 下
  // // // Hウェブ縦＿右＿外側
  ctx.moveTo(311, 194) // 上
  ctx.quadraticCurveTo(316, 219, 316, 219) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ横1(先端)
  topSidePartOfWebWithJoint(ctx, webColor, laceColor, stitchColor)
  // ウェブ横2
  middleSidePartOfWeb(ctx, webColor, stitchColor, 15, 35)
}
